import Lookup from 'src/componentes/select2';

const TipoRiscoLookup = ({ clearable = false, ...props }) => {
  return (
    <Lookup
      labelKey="descricao"
      valueKey="id"
      url="/TipoRiscoLookup"
      clearable={clearable}
      {...props}
    />
  );
};

export default TipoRiscoLookup;
